import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';
import ActionsApp from '@sharedComponent/app-action-reducer/action';
import Actions from '../action';
import { appConstant, apiUrl } from '@constants';
import { getKeyAndToken } from '@helpers';

export function* getCampaignListWorker({ companyId, history }) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_CAMPAIGN_DD}${companyId}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getCampaignDropdownSuccess(res.data.messages));
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		// if (authKey) yield put(ActionsApp.creators.removeUser(authKey, history));
		yield put(Actions.creators.getCampaignDropdownFail());
	}
}

export function* addCampaignWorker({ request, history }) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.ADD_CAMPAIGN}`;
		const res = yield call(Axios.post, uri, request, { headers: { Authorization: authToken } });
		yield put(Actions.creators.addCampaignSuccess(res.data.messages));
		yield history.goBack();
		message.success(res.data.messages);
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		// if (authKey) yield put(ActionsApp.creators.removeUser(authKey, history));
		yield put(Actions.creators.addCampaignFail());
	}
}

export default function* addCampaignWatcher() {
	yield takeEvery(Actions.types.GET_CAMPAIGN_DD_STARTED, getCampaignListWorker);
	yield takeEvery(Actions.types.ADD_CAMPAIGN_STARTED, addCampaignWorker);
}
